/**
 * hotspotCoords.js — DEAD SIGNAL cinematic hotspot geometry.
 *
 * Each entry maps a scene id → { hotspotId → { left, top, width, height, cursor } },
 * all expressed as PERCENTAGES of the .cine-container-16-9 box.
 *
 * Why percentages work everywhere: the container is always a true 16:9 box
 * (it letterboxes/pillarboxes but never distorts) and the 16:9 video fills it
 * with zero crop. So a given percentage lands on the exact same point of the
 * painted frame at every viewport size, zoom level, portrait/landscape, and
 * whether or not the evals panel is open. Calibrate once → glued everywhere.
 *
 * These values were calibrated in the in-app Hotspot Editor against the real
 * mp4 frames and promoted from .ds-hotspots.local.json. To re-calibrate, enable
 * the editor (localhost is always on; elsewhere set localStorage
 * 'ds_hotspot_editor'='1' and reload), drag the boxes, and re-export.
 *
 * Scope: consumed ONLY by CinematicStage.jsx, which renders the MP4 demo scenes
 * gated by isCinematicScene() — ds_craine_car, ds_helios_lobby, ds_helios_office,
 * and the explorable ds_elevator_down. These are the only scenes in the demo;
 * the legacy Three.js renderer and the full-game diorama scenes were retired in
 * the move to an all-MP4 scene approach. exit/navigate hotspots surface as HUD
 * buttons, never as hover regions, so they have no entry here.
 */
export const HOTSPOT_COORDS = {
  ds_craine_car: {
    'dsc-file': { left: '64%', top: '72%', width: '39%', height: '32.5%', cursor: 'pointer' },
    'dsc-spire': { left: '46%', top: '8.3%', width: '16.4%', height: '29.1%', cursor: 'help' },
    'dsc-radio': { left: '39.2%', top: '80.7%', width: '19.3%', height: '10.4%', cursor: 'help' },
    'dsc-police-car-sirens': { left: '41.1%', top: '65.7%', width: '15%', height: '13%', cursor: 'help' },
    'dsc-dispatch-radio': { left: '57%', top: '52.3%', width: '6.8%', height: '17.2%', cursor: 'help' },
    'dsc-CAD-unit': { left: '65.8%', top: '57.6%', width: '14.6%', height: '13.9%', cursor: 'help' },
    'dsc-rearview-mirror': { left: '45%', top: '0%', width: '24.1%', height: '8.1%', cursor: 'help' },
  },
  ds_helios_lobby: {
    'dsl-reception': { left: '41.9%', top: '48.2%', width: '4.8%', height: '6.8%', cursor: 'pointer' },
    'dsl-sunmark': { left: '34.2%', top: '14.7%', width: '14.1%', height: '32.1%', cursor: 'help' },
    'dsl-water': { left: '14.6%', top: '0%', width: '12.3%', height: '62.3%', cursor: 'help' },
    'dsl-ping': { left: '2.7%', top: '50%', width: '8%', height: '16.4%', cursor: 'help' },
    'dsl-terminal': { left: '85.3%', top: '52.8%', width: '13.2%', height: '39.8%', cursor: 'pointer' },
    'dsl-security': { left: '57.4%', top: '53.6%', width: '13.6%', height: '9.7%', cursor: 'help' },
    'dsl-elevator': { left: '73.8%', top: '29.4%', width: '11.1%', height: '51.9%', cursor: 'pointer' },
    'dsl-donation': { left: '34.7%', top: '51.2%', width: '3.4%', height: '3.3%', cursor: 'help' },
    'dsl-camera-1': { left: '1.7%', top: '10.2%', width: '9%', height: '15.9%', cursor: 'help' },
    'dsl-camera-2': { left: '85.4%', top: '10.8%', width: '7.8%', height: '9.4%', cursor: 'help' },
  },
  ds_helios_office: {
    'dso-celeste': { left: '68.6%', top: '47.2%', width: '6%', height: '10.2%', cursor: 'help' },
    'dso-manifest': { left: '41.5%', top: '72.4%', width: '16%', height: '14%', cursor: 'pointer' },
    'dso-terminal': { left: '12.8%', top: '54.6%', width: '17.7%', height: '28%', cursor: 'pointer' },
    'dso-chair': { left: '42.6%', top: '48.3%', width: '14.4%', height: '18.9%', cursor: 'help' },
    'dso-candle': { left: '80.6%', top: '60.9%', width: '8%', height: '24%', cursor: 'help' },
    'dso-hargrove-water': { left: '62.9%', top: '69.4%', width: '7.8%', height: '16.1%', cursor: 'help' },
  },
  ds_elevator_down: {
    'dse-trash-can': { left: '86.8%', top: '58.9%', width: '12.9%', height: '40.5%', cursor: 'help' },
    'dse-city-skyline': { left: '0.2%', top: '0.3%', width: '28.2%', height: '48.8%', cursor: 'help' },
    'dse-23rd-floor-sign': { left: '87.7%', top: '5.3%', width: '10.8%', height: '41%', cursor: 'help' },
  },
};
